import { ReactNode, useState } from 'react';

import { useAuth } from '#root/hooks';
import { Navbar, Sidebar } from '#root/components';
import { GuveryAlert } from '#root/ui-components';
import { Banner } from '#root/ui-components/extended';
import { USER_PROFILE } from '#root/constants/navigation';

import styles from './unifiedLayout.module.scss';

interface UnifiedLayoutProps {
  children: ReactNode;
}

const UnifiedLayout = (props: UnifiedLayoutProps) => {
  const { children } = props;
  const { usuario } = useAuth();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  const activeAlert = usuario?.is_active !== 1 || usuario?.wsp === null;
  const textAlert = !usuario?.wsp
    ? 'Ingresa tu Whatsapp para activar la cuenta.'
    : 'Verifica tu correo para activar tu cuenta.';

  return (
    <div className={styles.unifiedLayout}>
      <Navbar
        openMobile={isMobileNavOpen}
        onMobileNavChange={() => setMobileNavOpen(!isMobileNavOpen)}
      />
      <Sidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={styles.layoutWrap}>
        <div className={styles.layoutContainer}>
          <main className={styles.layoutContent}>
            <Banner />
            {activeAlert && (
              <GuveryAlert
                severity="warning"
                message={textAlert}
                actionText="Activar Cuenta"
                href={USER_PROFILE}
              />
            )}
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default UnifiedLayout;
